import React from "react";

interface HeaderButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  ariaLabel?: string;
}

const HeaderButton: React.FC<HeaderButtonProps> = ({
  icon,
  label,
  onClick,
  ariaLabel,
}) => (
  <button
    className="flex flex-col items-center justify-center px-2 py-1 focus:outline-none group cursor-pointer"
    onClick={onClick}
    aria-label={ariaLabel || label}
  >
    {icon}
    <span className="text-xs text-[#222] font-medium group-hover:underline mt-1">
      {label}
    </span>
  </button>
);

export default HeaderButton;
